/**
 * Preferințele de UI ale widgetului (deschis/închis, dimensiune, poziție
 * după un drag), per tab (sessionStorage) - supraviețuiesc navigării/
 * refresh-ului în același tab, la fel ca istoricul conversației (chatHistory.ts).
 */
export interface WidgetUiState {
  open?: boolean;
  width?: number;
  height?: number;
  left?: number;
  top?: number;
}

function storageKey(appId: string): string {
  return `aig_widget_ui_${appId}`;
}

export function loadWidgetState(appId: string): WidgetUiState {
  try {
    const raw = sessionStorage.getItem(storageKey(appId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    return parsed && typeof parsed === "object" ? (parsed as WidgetUiState) : {};
  } catch {
    return {};
  }
}

export function saveWidgetState(appId: string, patch: Partial<WidgetUiState>): void {
  try {
    const next = { ...loadWidgetState(appId), ...patch };
    sessionStorage.setItem(storageKey(appId), JSON.stringify(next));
  } catch {
    // storage indisponibil (private mode etc.) - preferința rămâne doar în memorie
  }
}
